import { GdsDrawer } from "@gds/web-components/react"
import PropTypes from "prop-types"
import { ReportPages } from "./ReportsHelper"

export default function ReportsSideMenu({ open, toggleOpen, page, setPage = () => { }, showSweeps }) {
    const menuItems = [
        { label: "Overview", page: ReportPages.Overview },
        { label: "Detailed View", page: ReportPages.Detailed },
        ...(showSweeps ? [{ label: "Sweeps", page: ReportPages.Sweeps }] : []),
    ];

    return (
        <GdsDrawer side="left" expanded={true} drawer-toggle={toggleOpen}>
            <div className="reports-side-menu-header">Reports</div>
            {open && menuItems.map(({ label, page: menuPage }) => (
                <button
                    key={menuPage}
                    onClick={() => setPage(menuPage)}
                    className={`reports-side-menu-item ${page === menuPage ? 'selected' : ''}`}
                    type="button"
                >
                    {label}
                </button>
            ))}
        </GdsDrawer>
    );
}

ReportsSideMenu.propTypes = {
    open: PropTypes.bool,
    toggleOpen: PropTypes.func,
    page: PropTypes.string,
    setPage: PropTypes.func,
    showSweeps: PropTypes.bool,
};